import { useAuth, useOrganization } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'
import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { billingKeys } from '@/lib/queryKeys'
import { fetchBillingCredits } from '../api/api'
import type { BillingCreditsResponse } from '../types'

/** The purchase and compensation credits added in a period.
 *
 * Reads the credit rows directly, so an open month answers as readily as a
 * closed one. */
export function useBillingCreditsQuery(period: string) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery<BillingCreditsResponse>({
    queryKey: billingKeys.credits(organization?.id ?? '', period),
    queryFn: async ({ signal }) => {
      const token = await getToken()
      if (!token) throw new Error('No auth token available')
      return fetchBillingCredits(token, period, signal)
    },
    enabled: !!organization?.id,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
